/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PostSaveDebtorCollectionMutationRequest, PostSaveDebtorCollectionMutationResponse, PostSaveDebtorCollectionPathParams, PostSaveDebtorCollection401, PostSaveDebtorCollection403 } from "../../models/PostSaveDebtorCollection";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPostSaveDebtorCollectionUrl({ debtorCode }: { debtorCode: PostSaveDebtorCollectionPathParams["debtorCode"] }) {
  const res = { method: 'POST', url: `/api/v1/debtors/${debtorCode}/collections` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections}
 */
export async function postSaveDebtorCollection({ debtorCode, data }: { debtorCode: PostSaveDebtorCollectionPathParams["debtorCode"]; data: PostSaveDebtorCollectionMutationRequest }, config: Partial<RequestConfig<PostSaveDebtorCollectionMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostSaveDebtorCollectionMutationResponse, ResponseErrorConfig<PostSaveDebtorCollection401 | PostSaveDebtorCollection403>, PostSaveDebtorCollectionMutationRequest>({ method : "POST", url : getPostSaveDebtorCollectionUrl({ debtorCode }).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}